import { render, staticRenderFns } from "./radio-block.html?vue&type=template&id=b24b3f62&scoped=true&"
import script from "./radio-block.js?vue&type=script&lang=js&"
export * from "./radio-block.js?vue&type=script&lang=js&"
import style0 from "./radio-block.scss?vue&type=style&index=0&id=b24b3f62&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b24b3f62",
  null
  
)

export default component.exports